import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PrivacyAndPolicy() {
    const { t } = useTranslation()
    return (
        <div className="flex flex-col items-center justify-center gap-4 p-6">
            <div className="flex flex-col items-center gap-3">
                <h1 className="text-2xl font-bold text-primary">{t('Privacy Policy')}</h1>
            </div>

            <div className="flex flex-col items-center gap-3">
                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph1')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph2')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph3')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph4')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph5')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph6')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph7')}
                </p>

                <p className="max-w-3xl text-sm text-foreground">
                    {t('privacy.paragraph8')}
                </p>
            </div>

        </div>
    );
}
